/* eslint-disable max-len */
import { useEffect, useState } from 'react';

import Cookies from 'js-cookie';
import { useStaticQuery, graphql } from 'gatsby';

const useAffiliate = ({
	setAffiliateFunc,
	checkout,
	setCheckoutItem,
	updateLineItems,
	updateCheckoutDiscount,
	isCartFlyoutOpen,
}) => {
	const [affiliateLoading, setAffiliateLoading] = useState(false);

	const { wp } = useStaticQuery(
		graphql`
			{
				wp {
					globalSettings {
						acfGlobalSettings {
							affiliateLinks {
								affiliateCode
								shopifyDiscountCode
							}
						}
					}
				}
			}
		`
	);
	const affiliateCodesWP = wp.globalSettings.acfGlobalSettings.affiliateLinks;

	const isUpdateLineItemsAffiliateAttrib = () => {
		if (checkout.lineItems?.length) {
			const cookieAffiliate = Cookies.get('affiliate') || 'null';
			const itemsNotMatchingAffiliateCookie = checkout.lineItems
				.filter(item => {
					const itemAffiliate = item.attributes.find(obj => obj.key === '_AID')?.value;
					return itemAffiliate !== cookieAffiliate;
				})
				.map(item => {
					const newCustomAttributes = item.attributes
						.filter(attrib => attrib.key !== '_AID')
						.concat({
							key: '_AID',
							value: cookieAffiliate,
						});
					return {
						id: item.id,
						merchandiseId: item.merchandise.id,
						quantity: item.quantity,
						attributes: newCustomAttributes,
					};
				});
			if (itemsNotMatchingAffiliateCookie.length) {
				return itemsNotMatchingAffiliateCookie;
			}
			return false;
		}
		return false;
	};

	const validateAffiliateCode = affiliateCode => {
		const codeDetails = affiliateCodesWP.find(code => {
			return affiliateCode === code.affiliateCode;
		});
		return codeDetails;
	};

	const setCookieValue = () => {
		// handle affiliate value
		const params = new URL(window.location).searchParams;
		const affiliateValue = params.get('bbAffiliateID');
		const cookieValue = Cookies.get('affiliate');
		const validCookieValue = cookieValue && cookieValue !== 'expired' && validateAffiliateCode(cookieValue);

		if (cookieValue && !validCookieValue) Cookies.set('affiliate', 'expired', {domain: process.env.GATSBY_COOKIE_DOMAIN});
		if (affiliateValue && !validCookieValue) {
			const codeDetails = validateAffiliateCode(affiliateValue);
			codeDetails
				&& Cookies.set('affiliate', affiliateValue, {expires: 30, domain: process.env.GATSBY_COOKIE_DOMAIN});
		}
	};

	const updateLineItemsAffiliateAttrib = async() => {
		// update lineitems
		const lineItemsToUpdate = isUpdateLineItemsAffiliateAttrib(checkout);
		if (lineItemsToUpdate) {
			// update the attributes
			await updateLineItems(checkout.id, lineItemsToUpdate);
		}
	};

	const handleAffiliate = async() => {
		setAffiliateLoading(() => true);
		// handle cookie value
		setCookieValue();
		// Update Lineitems affiliate attribs before applying the discount otherwise the discount won't be applied due to shopify custom script
		await updateLineItemsAffiliateAttrib();
		// apply discount after applying the affiliate attrib
		const res = await updateCheckoutDiscount();
		// update checkout after discount is applied
		res && await setCheckoutItem({ checkoutItem: res });

		setAffiliateLoading(() => false);
	};

	//	------------------------
	//	Handle Affiliate Cookie
	//	------------------------
	useEffect(() => {
		if (!checkout.id) return;
		handleAffiliate();
	}, [checkout, isCartFlyoutOpen]); // eslint-disable-line

	useEffect(() => {
		if (!checkout.id) return;
		setAffiliateFunc(() => handleAffiliate);
	}, [checkout]); // eslint-disable-line

	return {
		affiliateLoading,
	};
};

export default useAffiliate;
